import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-guinda to-guinda-darker p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden" data-testid="login-card">
        <div className="bg-guinda px-8 py-8 text-center">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-white/15 flex items-center justify-center mb-3">
            <MapPin className="w-9 h-9 text-white" />
          </div>
          <h1 className="font-heading text-xl font-bold text-white leading-tight">
            Plataforma Territorial
          </h1>
          <p className="text-white/80 text-xs mt-1">Municipio de Tampico, Tamaulipas</p>
        </div>
        <div className="px-8 py-8 text-center">
          <h2 className="font-heading text-lg font-bold text-slate-900 mb-1">Acceso restringido</h2>
          <p className="text-sm text-slate-500 mb-6">
            Inicia sesión con tu cuenta de Google autorizada para continuar.
          </p>
          <button data-testid="google-login-btn" onClick={login}
            className="w-full h-11 rounded-xl bg-guinda hover:bg-guinda-dark text-white font-semibold text-sm flex items-center justify-center gap-2 transition-colors">
            <LogIn className="w-4 h-4" /> Iniciar sesión con Google
          </button>
          <p className="text-[11px] text-slate-400 mt-4">
            Solo cuentas previamente autorizadas pueden acceder.
          </p>
        </div>
      </div>
    </div>
  );
}
